import { Component } from '@angular/core';
import { AboutBeachwatchVideoCaption } from 'src/app/models/app-constants';
import { BEACHWATCH_VISION_URL_EXTERNAL } from 'src/app/models/external-urls';
import { VideoPlayerOptions } from 'src/app/shared/angular-video-player/angular-video-player.component';
import { environment } from 'src/environments/environment';


@Component({
	selector: 'app-about-beachwatch',
	templateUrl: './about-beachwatch.component.html',
	styleUrls: ['./about-beachwatch.component.scss']

})
export class AboutBeachwatchComponent {
	public BEACHWATCH_VISION_URL = BEACHWATCH_VISION_URL_EXTERNAL;
	public aboutBeachwatchVideoCaption : string = AboutBeachwatchVideoCaption;
	public videoPlayerOptions : VideoPlayerOptions = {
		autoplay: true, 
		preload : 'auto', 
		controls: true, 
		title : 'About Beachwatch', 
		sources: [{ source : "assets/videos/AboutBeachwatch/" + environment.aboutBeachwatchVideo, type : "video/mp4" }]
	};	
}
